import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from "sweetalert2"; 
import {
  FaBell,
  FaBullseye,
  FaCalendarAlt,
  FaHamburger, 
} from "react-icons/fa";
import { GiArcheryTarget, GiDart, GiTargetArrows, GiTargetShot } from "react-icons/gi";
import { MdAddTask } from "react-icons/md";
import HomeTabs from "../pages/HomeTabs";
import { useNavigate } from "react-router-dom";
import { BiBullseye, BiTargetLock } from "react-icons/bi";
import { Target } from "react-feather";
import UserNavbar from "./UserNavbar";
import UserTabMenu from "./UserTabMenu";


export default function UserOperation() {
  const orgId = localStorage.getItem("organization_id");
  const [dutyType, setDutyType] = useState("Weekly");
  const [tasks, setTasks] = useState({
    Weekly: { todo: [], complete: [] },
    Monthly: { todo: [], complete: [] },
    Quarterly: { todo: [], complete: [] },
    Yearly: { todo: [], complete: [] },
  });
  const [modalData, setModalData] = useState({ id: null, title: "", column: "todo" });
  const [isEditing, setIsEditing] = useState(false);
const assignee_id = localStorage.getItem("assignee_id");

  const showToast = (icon, title) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
};


 const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
   useEffect(() => {
     const assignee_id = localStorage.getItem("assignee_id");
     if (!assignee_id) {
       navigate("/"); 
     }
 
     // 👇 load dark mode preference
     const savedTheme = localStorage.getItem("darkMode") === "true";
     setDarkMode(savedTheme);
     document.body.classList.toggle("dark", savedTheme);
   }, [navigate]);



  // Capitalize timeframe consistently
  const normalizeTimeframe = (tf) => {
    if (!tf) return "Weekly";
    return tf.charAt(0).toUpperCase() + tf.slice(1).toLowerCase();
  };

  // Fetch tasks from API
  useEffect(() => {
    if (!assignee_id) return;
    const fetchTasks = async () => {
      try {
        const res = await axios.get(`${baseurl}getProjectTaskDetailsByAssignee/${assignee_id}`);
        const grouped = {
          Weekly: { todo: [], complete: [] },
          Monthly: { todo: [], complete: [] },
          Quarterly: { todo: [], complete: [] },
          Yearly: { todo: [], complete: [] },
        };

        res.data.forEach((task) => {
          const timeframe = normalizeTimeframe(task.timeframe);
          if (grouped[timeframe]) {
            grouped[timeframe][task.status || "todo"].push({
              id: task.id?.toString() || Date.now().toString(),
              title: task.title,
              icon: "bi-list-task",
              position: task.position || 0,
              status: task.status || "todo",
            });
          }
        });

        setTasks(grouped);
      } catch (err) {
        console.error("Failed to fetch tasks:", err);
      }
    };
    fetchTasks();
  }, [orgId]);

  // Handle drag & drop
  // Handle drag & drop
const onDragEnd = async (result) => {
  const { source, destination } = result;
  if (!destination) return;

  setTasks((prev) => {
    const updated = { ...prev };
    const current = updated[dutyType];

    if (source.droppableId !== destination.droppableId) {
      const sourceTasks = Array.from(current[source.droppableId]);
      const destTasks = Array.from(current[destination.droppableId]);
      const [removed] = sourceTasks.splice(source.index, 1);
      removed.status = destination.droppableId;
      destTasks.splice(destination.index, 0, removed);

      updated[dutyType] = {
        ...current,
        [source.droppableId]: sourceTasks,
        [destination.droppableId]: destTasks,
      };

      // 🔥 Call API to update status in DB
      axios.post(`${baseurl}/addOrUpdateProjectOperationTask`, {
        id: removed.id,
        organization_id: localStorage.getItem("user_org_id"),
        title: removed.title,
        timeframe: dutyType,
        position: removed.position || 0,
        status: removed.status, // "complete" or "todo"
        recurring: modalData.recurring ? 1 : 0, 
      }).catch((err) => console.error("Update failed:", err));


      
    } else {
      const items = Array.from(current[source.droppableId]);
      const [reordered] = items.splice(source.index, 1);
      items.splice(destination.index, 0, reordered);

      updated[dutyType] = { ...current, [source.droppableId]: items };
    }

    return updated;
  });
};


  // Open modal for add
  const handleAddClick = () => {
    setModalData({ id: null, title: "", column: "todo" });
    setIsEditing(false);
    window.bootstrap.Modal.getOrCreateInstance(document.getElementById("taskModal")).show();
  };

  // Open modal for edit
  const handleEditClick = (task, col) => {
    setModalData({ ...task, column: col });
    setIsEditing(true);
    window.bootstrap.Modal.getOrCreateInstance(document.getElementById("taskModal")).show();
  };

  // Save new or edited task (API call)
  const handleSaveTask = async () => {
  try {
    const payload = {
      id: modalData.id,
      organization_id: localStorage.getItem("user_org_id"),
      title: modalData.title,
      timeframe: normalizeTimeframe(dutyType),
      position: 0,
      status: modalData.column,
      recurring: modalData.recurring ? 1 : 0, 
    };

    const res = await axios.post(`${baseurl}/addOrUpdateProjectOperationTask`, payload);

    setTasks((prev) => {
      const updated = { ...prev };
      if (isEditing) {
        updated[dutyType][modalData.column] = updated[dutyType][modalData.column].map((t) =>
          t.id === res.data.project.id.toString() ? { ...res.data.project, icon: "bi-list-task" } : t
        );
      } else {
        updated[dutyType][modalData.column] = [
          ...updated[dutyType][modalData.column],
          { ...res.data.project, icon: "bi-list-task" },
        ];
      }
      return updated;
    });

    window.bootstrap.Modal.getInstance(document.getElementById("taskModal")).hide();

    // 🎉 Success toast
    showToast("success", isEditing ? "Task updated successfully!" : "Task added successfully!");
  } catch (err) {
    console.error("Save failed:", err);
    showToast("error", "Failed to save task!");
  }
};


  // Delete task (local only for now — can add API delete)
 
const handleDelete = async (id, col) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to delete this task?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      const res = await axios.delete(`${baseurl}/deleteProjectOperationTask`, {
        params: { id, organization_id: orgId }
      });

      // Update local state only if API succeeds
      setTasks((prev) => ({
        ...prev,
        [dutyType]: {
          ...prev[dutyType],
          [col]: prev[dutyType][col].filter((t) => t.id !== id),
        },
      }));

      // Swal.fire("Deleted!", "Task deleted successfully.", "success");
      showToast("success", "Task deleted successfully!");

    } catch (err) {
      console.error("Delete failed:", err);
      // Swal.fire("Error!", "Failed to delete task.", "error");
      showToast("error", "Failed to delete task!");
    }
  }
};

 

  return (
    <> 
<UserNavbar/>

    <UserTabMenu />

    <div className="container-fluid py-4">
      {/* Header with Dropdown */}
      <div className="d-flex align-items-center mb-4">
        <div className="dropdown">
          <button className="btn glowbtn dropdown-toggle me-2" type="button" data-bs-toggle="dropdown">
            {/* <i className="bi bi-chevron-down me-2"></i>  */}
            {dutyType} Duties
          </button>
          <ul className="dropdown-menu">
            {["Weekly", "Monthly", "Quarterly", "Yearly"].map((type) => (
              <li key={type}>
                <button className="dropdown-item" onClick={() => setDutyType(type)}>
                  {type}
                </button>
              </li>
            ))}
          </ul>
        </div>
        {/* <div>
          <button className={`btn new-project-btn d-flex align-items-center gap-1 px-3 py-2 tab4 mainttl ${darkMode ? "dark" : ""} `} onClick={handleAddClick}>
            <i className="bi bi-plus-lg me-2"></i> Add {dutyType} Task
          </button>
        </div> */}
      </div>

      {/* Task Columns */}
      <DragDropContext onDragEnd={onDragEnd}>
  <div className="row">
    {["todo", "complete"].map((col) => (
      <div className="col-md-6" key={col}>
        <Droppable droppableId={col}>
          {(provided) => (

            <>
<h5
  className={` text-uppercase crdf2 ${darkMode ? "dark" : ""} ${
    col === "todo" ? "opbgn" : "opbgn2"
  }`}
>
  {col === "todo" ? "TO DO" : "COMPLETE"}
</h5>

            <div
              className={`p-3 rounded sgha1 shadow-sm min-vh-100  crdf2 ${darkMode ? "dark" : ""} ${
                col === "todo" ? "opbg" : "opbg2"
              }`}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {/* <h5 className="fw-bold mb-3 text-uppercase">
                {col === "todo" ? "TO DO" : "COMPLETE"}
              </h5> */}

              <div className="row g-3 ">
                {tasks[dutyType][col].map((task, index) => (
                  <Draggable draggableId={task.id.toString()} index={index} key={task.id}>
                    {(provided) => (
                      <div
                        className="col-md-6 "
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="card h-100 shadow-sm ">
                          <div className={`card-body d-flex align-items-center justify-content-between 
                            p-2 pcard ${darkMode ? "dark" : ""}`}>
                            {/* Task title & icon */}
                            <div className="d-flex align-items-center">
                              {/* <i className={`${task.icon} fs-5 me-3 text-primary`}></i> */}
                       
                              <div className="menu-icon"> 
                              <BiTargetLock size={20} /></div>
                              <span className="fw-medium">{task.title}</span>
                            </div>

                            {/* Dropdown menu for actions */}
                            <div className="dropdown">
                              <button
                                className="btn btn-sm btn-light"
                                type="button"
                                id={`dropdownMenuButton-${task.id}`}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="bi bi-three-dots-vertical"></i>
                              </button>
                              <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby={`dropdownMenuButton-${task.id}`}
                              >
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleEditClick(task, col)}
                                  >
                                    <i className="bi bi-pencil me-2"></i> Edit
                                  </button>
                                </li>
                                {/* <li>
                                  <button
                                    className="dropdown-item text-danger"
                                    onClick={() => handleDelete(task.id, col)}
                                  >
                                    <i className="bi bi-trash me-2"></i> Delete
                                  </button>
                                </li> */}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              </div>
              {provided.placeholder}
            </div>
            </>
          )}
        </Droppable>
      </div>
    ))}
  </div>
</DragDropContext>


      {/* Modal for Add/Edit Task */}
      <div className="modal fade" id="taskModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEditing ? "Edit Task" : "Add Task"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Task Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalData.title}
                  onChange={(e) => setModalData({ ...modalData, title: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Column</label>
                <select
                  className="form-select"
                  value={modalData.column}
                  onChange={(e) => setModalData({ ...modalData, column: e.target.value })}
                >
                  <option value="todo">To Do</option>
                  <option value="complete">Complete</option>
                </select>
              </div>


              <div className="mb-3 form-check">
  <input
    type="checkbox"
    className="form-check-input"
    id="recurringCheck"
    checked={modalData.recurring || false}
    onChange={(e) =>
      setModalData({ ...modalData, recurring: e.target.checked })
    }
  />
  <label className="form-check-label" htmlFor="recurringCheck">
    Recurring Task
  </label>
</div>


            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSaveTask}>
                {isEditing ? "Save Changes" : "Add Task"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
